import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';
import { QuotationButton } from '../../../../shared';
import { GetCommertialsConditionsResponse } from '../../../../../../../../shared/interfaces';
import { CoveragePerPlanId, PersonalEffectsPaymentMethodForm, PersonalEffectsQuotationForm } from './StepThreeFormProvider';
import { PersonalEffectsQuotationComponent, PersonalEffectsQuotationRequest } from '../../../../../../../../shared/interfaces/services/personal-effects-quotation-service';

// TODO: Modificar Interfaces. Crear las propias de Efectos Personales
interface StepThreeFormContextProps {
  stepThreePersonalEffectsQuotationForm:      FormInstance<PersonalEffectsQuotationForm>;
  personalEffectsPaymentMethodsForm:          FormInstance<PersonalEffectsPaymentMethodForm>;

  labelButton:                                QuotationButton;
  setLabelButton:                             Dispatch<SetStateAction<QuotationButton>>;

  quotationResponse?:                         any | undefined;
  setQuotationResponse:                       Dispatch<SetStateAction<any | undefined>>;

  canGetCoveragesPerPlanByTab:                CoveragePerPlanId | undefined
  setCanGetCoveragesPerPlanByTab:             Dispatch<SetStateAction<CoveragePerPlanId | undefined>>;

  commertialConditions:                       GetCommertialsConditionsResponse | undefined;
  clearPrimaFieldsOnFormChange:               () => void;

  generatePersonalEffectsQuotationForm:       () => PersonalEffectsQuotationRequest;

  personalEffectsQuotationComponents:                   Array<PersonalEffectsQuotationComponent>;

  quotationTabs:                              Array<any>;
  setQuotationTabs:                           Dispatch<SetStateAction<Array<any>>>;

  createTabs:                                 () => void;
  handlerOnClickQuotation:                    (form: PersonalEffectsQuotationRequest) => Promise<void>;
  handlerOnClick:                             () => Promise<void>;
}

export const StepThreeFormContext = createContext(
  {} as StepThreeFormContextProps
);
